import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "comp-overall-value-tooltip",
  templateUrl: "./comp-overall-value-tooltip.component.html",
  styleUrls: ["./comp-overall-value-tooltip.component.scss"],
})
export class CompOverallValueTooltipComponent implements OnInit {
  @Input() overallData;
  @Input() column;
  @Input() kpiId;
  @Input() overallDataColors;
  @Input() studentTooltip;
  metricId;

  constructor() {}

  ngOnInit() {
    this.metricId = this.kpiId ? this.kpiId : this.column.id;
  }
}
